import constants from '../../../../../ahm-constants';

const { REFER_A_FRIEND_OFFER_ID } = constants;
const offerBehaviours = {
  [REFER_A_FRIEND_OFFER_ID.FRIEND]: {
    showAlertOnSuccess: true,
    showAlertWhenNoReferralCode: false,
    showFindCover: true,
    showMemberLogin: false,
  },
  [REFER_A_FRIEND_OFFER_ID.REFER]: {
    showAlertOnSuccess: false,
    showAlertWhenNoReferralCode: false,
    showFindCover: false,
    showMemberLogin: true,
  },
};

// @ts-expect-error - Automatic, Please fix when editing this file
const getOfferBehaviours = (offerId) => offerBehaviours[offerId];

export default getOfferBehaviours;
